import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { convertPreview } from "../types/preview"
import { Scanner } from "../types/scanner"
import { STALE_TIME } from "../types/staleTime"
import { apiGet, apiPost } from "./query"

const ENDPOINT = "preview"

export const usePreviewGet = ({ id }: Pick<Scanner, "id">) => {
  return useQuery({
    queryKey: ["preview", id],
    queryFn: async () => (await apiGet(`${ENDPOINT}/${id}`, convertPreview)).data,
    staleTime: STALE_TIME.MIN_30,
    retry: 0,
    refetchInterval: ({ state }) => {
      if (state.status === "error") return 0
      if (state.data?.hasFile) return 0

      return 5000
    },
    enabled: id > 0,
  })
}

export const usePreviewCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id }: Pick<Scanner, "id">) => apiPost(`${ENDPOINT}/${id}`),
    onSuccess: (_, { id }) => queryClient.invalidateQueries({ queryKey: ["preview", id] })
  })
}
